import { render, staticRenderFns } from "./scoreruleDetailMod.vue?vue&type=template&id=37c78c54&scoped=true&"
import script from "./scoreruleDetailMod.vue?vue&type=script&lang=js&"
export * from "./scoreruleDetailMod.vue?vue&type=script&lang=js&"
import style0 from "./scoreruleDetailMod.vue?vue&type=style&index=0&id=37c78c54&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c78c54",
  null
  
)

export default component.exports